<template>
    <div id="userList">
        <div class="search">
            <!--<div class="p_select el_select_org">
                <div class="search_label">检测站点</div>
                <el-select v-model="orgId" clearable filterable placeholder="请选择检测站点" @change="changeOrg()">
                    <el-option
                            v-for="item in orgArr"
                            :key="item.orgId"
                            :label="item.orgName"
                            :value="item.orgId"
                    ></el-option>
                </el-select>
            </div>-->
            <div class="p_select">
                <div class="search_label">检测技师</div>
                <el-select clearable v-model="workerId" filterable placeholder="请选择技师" @change="getListData">
                    <el-option
                            v-for="item in workerList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </div>
            <div class="p_select">
                <el-select v-model="workerPlanId" clearable filterable placeholder="请选择计划" @change="getListData" >
                    <el-option
                            v-for="item in targetPlanList"
                            :key="item.workerPlanId"
                            :label="item.workerPlanName"
                            :value="item.workerPlanId"
                    ></el-option>
                </el-select>
            </div>
            <div class="p_select">
                <el-button class="search_btn" @click="getListData" >查询</el-button>
                <el-button class="add_btn" @click="exportTable('#listData')" >导出</el-button>
            </div>
        </div>
        <div class="table">
            <el-table id="listData" :data="listData" style="width: 100%" :height=winHeight ref="table_2"
                      :cell-style="cellStyle" :header-cell-style="tableHeaderColor" show-summary :summary-method="getSummaries" >


                <el-table-column prop="workerName" label="姓名" align="left" v-if="workerId"></el-table-column>
                <el-table-column prop="positionName" label="项目名称" align="left"></el-table-column>

                <!--<el-table-column prop="checkTarget" label="预计目标(台)" align="left" sortable></el-table-column>
                <el-table-column prop="checkNum" label="预检数量(台)" align="left" sortable></el-table-column>-->

                <el-table-column label="预计目标" align="left" sortable :sort-method="(a,b)=>{return a.checkTarget - b.checkTarget}">
                    <template slot-scope="scope" v-if="scope.row.checkTarget">
                        <span>{{scope.row.checkTarget}}</span><span>{{scope.row.mainUnit ? scope.row.mainUnit : '台'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="预检数量" align="left" sortable :sort-method="(a,b)=>{return a.checkNum - b.checkNum}">
                    <template slot-scope="scope" v-if="scope.row.checkNum">
                        <span>{{scope.row.checkNum}}</span><span>{{scope.row.mainUnit ? scope.row.mainUnit : '台'}}</span>
                    </template>
                </el-table-column>


                <el-table-column prop="conversionRate" label="预检达成率" align="left" sortable :sort-method="(a,b)=>{return a.checkNumRate - b.checkNumRate}">
                    <template slot-scope="scope">
                        <span>{{scope.row.checkNumRate >0? (scope.row.checkNumRate+"%") : '-'}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="检测异常数量" align="left" sortable :sort-method="(a,b)=>{return a.abnormal - b.abnormal}">
                    <template slot-scope="scope" v-if="scope.row.abnormal">
                        <span>{{scope.row.abnormal}}</span><span>{{scope.row.mainUnit ? scope.row.mainUnit : '台'}}</span>
                    </template>
                </el-table-column>


                <el-table-column label="渗透率目标" align="left" sortable :sort-method="(a,b)=>{return a.expectation - b.expectation}">
                    <template slot-scope="scope" v-if="scope.row.expectation">
                        <span>{{scope.row.expectation}}{{scope.row.numUnit}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="成交数量" align="left" sortable :sort-method="(a,b)=>{return a.actual - b.actual}">
                    <template slot-scope="scope" v-if="scope.row.actual">
                        <span>{{scope.row.actual}}{{scope.row.numUnit}}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="expectationRate" label="渗透达成率" align="left" sortable :sort-method="(a,b)=>{return a.expectationRate - b.expectationRate}">
                    <template slot-scope="scope">
                        <span>{{scope.row.expectationRate >0? (scope.row.expectationRate+"%") : '-'}}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="disparityDay" label="日均渗透率目标差值" align="left" sortable></el-table-column>
                <el-table-column prop="disparityMonth" label="月均渗透率目标差值" align="left" sortable></el-table-column>




                <!--<el-table-column prop="abnormal" label="检测异常" align="left" sortable></el-table-column>
                <el-table-column prop="actual" label="实际完成" align="left" sortable></el-table-column>
                <el-table-column prop="conversion" label="转化数" align="left" sortable></el-table-column>
                <el-table-column prop="conversionRate" label="转化率" align="left" sortable :sort-method="(a,b)=>{return a.conversionRate - b.conversionRate}">
                    <template slot-scope="scope">
                        <span>{{scope.row.conversionRate >0? (scope.row.conversionRate+"%") : '-'}}</span>
                    </template>
                </el-table-column>-->
            </el-table>
        </div>
    </div>
</template>

<script>
  import net from "../../assets/js/public";
  import XLSX from "xlsx";
  import FileSaver from "file-saver";
  export default {
    name: "detectionSummary",
    data(){
      return {
        signInfo:'',
        workerId:'',
        workerList:[],
        workerPlanId:'',
        targetPlanList:[],

        listData:[],
        winHeight:'200',


        checkTargetSum : 0, // 预计目标合计
        checkNumSum : 0, // 预检数量合计
        abnormalSum : 0, // 检测异常数量合计
        expectationSum : 0, // 渗透率目标合计
        actualSum : 0, // 成交数量合计


      }
    },
    created() {
      let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      this.signInfo = signInfo
      this.getWorkerList()
      this.getPlanList()
    },
    methods:{
      // 表头样式
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return "background-color:#F3F7FB; color: #364556; text-align: left;font-size: 14px;height: 48px;font-weight: 500;font-family: 'PingFang SC';";
      },
      cellStyle({ row, column, rowIndex, columnIndex }) {
        if(row.columnIndex == 0){
          return 'color: #0D0E12;font-weight: 500;font-size: 14px;'
        }else{
          return 'color: #0D0E12;font-weight: 400;'
        }
      },
      // 合计
      getSummaries(param){
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }

          if(!this.workerId){
            if (index === 1) {
              sums[index] = this.checkTargetSum;
              return;
            }
            if (index === 2) {
              sums[index] = this.checkNumSum;
              return;
            }
            if (index === 3) {
                sums[index] = sums[1] >0 ? ((sums[2] / sums[1])*100).toFixed(2)+'%' : '-';
                return;
            }
            if (index === 4) {
                sums[index] = this.abnormalSum;
                return;
            }
            if (index === 5) {
                sums[index] = this.expectationSum;
                return;
            }
            if (index === 6) {
                sums[index] = this.actualSum;
                return;
            }
            if (index === 7) {
              sums[index] = this.expectationSum >0 ? ((this.actualSum / this.expectationSum)*100).toFixed(2)+'%' : '-';
              return;
            }
          }else {
            if (index === 2) {
              sums[index] = this.checkTargetSum;
              return;
            }
            if (index === 3) {
              sums[index] = this.checkNumSum;
              return;
            }
            if (index === 4) {
              sums[index] = sums[2] >0 ? ((sums[3] / sums[2])*100).toFixed(2)+'%' : '-';
              return;
            }
            if (index === 5) {
              sums[index] = this.abnormalSum;
              return;
            }
            if (index === 6) {
              sums[index] = this.expectationSum;
              return;
            }
            if (index === 7) {
              sums[index] = this.actualSum;
              return;
            }
            if (index === 8) {
              sums[index] = sums[6] >0 ? ((sums[7] / sums[6])*100).toFixed(2)+'%' : '-';
              return;
            }
          }

          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return Math.floor((prev + curr) * 100) / 100;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = '-';
          }
        });
        return sums;
      },


      //获取技师
      getWorkerList(){
        net.request("manage/workerPlan/getWorkerList","post",).then(res => {
          if (res.code === 0) {
            let planListData = res.data
            this.workerList = planListData
            this.workerId = ''
          } else {
            net.message(this, "获取数据失败", "warning");
          }
        })
      },
      //获取计划列表
      getPlanList(){
        net.request("manage/workerPlan/enableList","post", {orgId:this.orgId}).then(res => {
          if (res.code === 0) {
            let planListData = res.data
            this.targetPlanList = planListData
            this.workerPlanId = ''
          } else {
            net.message(this, "获取数据失败", "warning");
          }
        })
      },

      // 查询列表数据
      getListData(){
        if (this.workerPlanId === "" || this.workerPlanId === null) {
          net.message(this, "请选择需要查询的计划", "warning");
          return;
        }
        this.listData = []
        const body = {
          orgId: this.signInfo.orgId,
          workerId: this.workerId,
          workerPlanId: this.workerPlanId
        }
        net.request("manage/workerAchievement/workerReport", "post", null, body).then(res => {
          if(res.code === 0) {
            if(res.data){
              let data = res.data
              let checkTargetSum = 0 // 预计目标合计
              let checkNumSum = 0 // 预检数量合计
              let abnormalSum = 0 // 检测异常数量合计
              let expectationSum = 0 // 渗透率目标合计
              let actualSum = 0 // 成交数量合计
              data.forEach(item => {
                checkTargetSum += item.checkTarget*1
                checkNumSum += item.checkNum*1
                abnormalSum += item.abnormal*1
                expectationSum += item.expectation*1
                actualSum += item.actual*1

                item.checkNumRate = item.checkTarget > 0 ? ((item.checkNum / item.checkTarget)*100).toFixed(2) : 0  // 预检达成率(预检数量/预检目标)
                item.expectationRate = item.expectation > 0 ? ((item.actual / item.expectation)*100).toFixed(2) : 0 // 渗透达成率 （成交数量/渗透率目标）

                if(this.workerId){
                  item.disparityDay = (item.actual/26 - item.expectation/26).toFixed(2)  // 日均渗透率目标差值(成交数量/26-渗透率目标/26)
                }else {
                  item.disparityDay = (item.actual/30 - item.expectation/30).toFixed(2)  // 日均渗透率目标差值(成交数量/30-渗透率目标/30)
                }

                item.disparityMonth = item.actual - item.expectation  // 月均渗透率目标差值(成交数量-渗透率目标)

              })
              this.listData = data

              this.checkTargetSum = checkTargetSum
              this.checkNumSum = checkNumSum
              this.abnormalSum = abnormalSum
              this.expectationSum = expectationSum
              this.actualSum = actualSum

              const windiwHight = document.documentElement.clientHeight || document.body.clientHeight; // 可视屏幕高度
              this.winHeight = windiwHight  - 186;
              this.$nextTick(() => {
                this.$refs['table_2'].doLayout();
              })
            }else {
              net.message(this, res.msg, "warning");
              this.listData = []
            }

          }else {
            net.message(this, res.msg, "warning");
          }
        })
      },


      // 导出数据
      exportTable(elTableId) {
        var wb = XLSX.utils.table_to_book(document.querySelector(elTableId));
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        });
        try {
          FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            "检测技师成交合计.xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
      },
    },
    mounted() {
      window.addEventListener('keyup',this.handleKeyup)
    },
    beforeDestroy() {
      window.removeEventListener('keyup',this.handleKeyup)
    }
  };
</script>

<style lang="less" scoped>
    #userList {
        display: flex;
        flex-direction: column;
        margin: 24px 0 0 24px;
        background: #fff;
        padding-left: 24px;
        padding-right: 24px;
        .search {
            background: #fff;
            padding-top: 24px;
            margin-bottom: 24px;
            .p_select {
                display: flex;
                margin-right: 12px;
                font-size: 12px;
                float: left;
                .search_label{
                    font-family: 'PingFang SC';
                    font-style: normal;
                    margin-right: 12px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 40px;
                    color: #787E86;
                    white-space:nowrap
                }

                .el-input , .el-select{
                    width: 160px;
                }
            }
            .search_btn {
                background: #2B54FC;
                box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                border-radius: 4px;
                color: #FFFFFF;
                font-size: 14px;
            }
            .add_btn {
                height: 36px;
                background: rgba(148, 170, 204, 0.08);
                border: 1px solid #2B54FC;
                border-radius: 4px;
                font-size: 14px;
                color: #2B54FC;
            }
        }

        .pagination {
            position: relative;
            margin-top: 20px;

            .el-pagination {
                position: absolute;
                left: 0px;
            }

            .number .active {
                background: #009688 !important;
            }
        }
    }
</style>
<style lang="less">
    .el-table .cell {

        white-space: pre-line;
    }
</style>
